import { typographyStyles } from "@newsela/angelou";

import { SmallScreenPanelZIndex } from "@/view/ContentLayout/ContentLayout.style";

const { textXSObj } = typographyStyles;

export const toolTipIconCss = {
  marginLeft: "4px",
};

export const toolTipWrapperCss = {
  div: {
    display: "inline",
    marginRight: 1,
  },
};

const toolTipButtonCss = {
  marginTop: "4px",
  marginRight: "16px",
};

const bodyTextCss = {
  ...textXSObj,
  lineHeight: "16px",
};

export const toolTipCss = {
  Button: {
    root: toolTipButtonCss,
  },
  dialog: {
    body: bodyTextCss,
    root: {
      zIndex: SmallScreenPanelZIndex + 2,
    },
  },
};
